import { Stack } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { DashboardPage } from '../features/dashboard/dashboard.tsx';
import useAppStore from '../store/rootStore.ts';
import { createPageBackgroundSx } from '../styles/pageBackground.ts';

export const Route = createFileRoute('/dashboard')({
  component: DashboardRoute,
  beforeLoad: () => {
    if (!useAppStore.getState().config?.features.duneDashboardUrl) {
      throw redirect({ to: '/trade', replace: true });
    }
  },
});

const dashboardPageSx = createPageBackgroundSx();

function DashboardRoute() {
  return (
    <Stack sx={dashboardPageSx}>
      <DashboardPage />
    </Stack>
  );
}
